var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticStyle:{"height":"100%"}},[_c('v-container',{staticClass:"pa-0",staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }